import React, { useId } from 'react';
import ContentLoader from 'react-content-loader';

const toPositive = (value, fallback) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

const TextSkeleton = ({
  lines = 3,
  width = 72,
  lineWidths = [172, 140, 100],
  lineHeight = 8,
  gap = 4,
  rx = 2,
  backgroundColor = '#e2e8f0',
  foregroundColor = '#cbd5e1',
  speed = 1.2,
  className,
  style
}) => {
  const uniqueKey = useId().replace(/:/g, '');
  const lineCountBase = lines === '' || lines == null ? 1 : Number(lines);
  const normalizedLines = Number.isFinite(lineCountBase) && lineCountBase >= 0 ? Math.floor(lineCountBase) : 1;

  const hasPattern = lineWidths?.length > 0;
  const count = normalizedLines;

  if (count < 1) return null;

  const barHeight = toPositive(lineHeight, 8);
  const rowGap = toPositive(gap, 4);
  const defaultBarW = toPositive(width, 72);

  const widths = hasPattern
    ? Array.from({ length: count }, (_, i) => toPositive(lineWidths[i % lineWidths.length], defaultBarW))
    : Array.from({ length: count }, () => defaultBarW);

  const maxW = Math.max(...widths, 1);
  const padY = 1;
  const totalHeight = padY * 2 + count * barHeight + Math.max(0, count - 1) * rowGap;

  return (
    <ContentLoader
      uniqueKey={uniqueKey}
      speed={speed}
      width={maxW}
      height={totalHeight}
      viewBox={`0 0 ${maxW} ${totalHeight}`}
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
      className={className}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
    >
      {widths.map((w, i) => (
        <rect
          key={i}
          x="0"
          y={padY + i * (barHeight + rowGap)}
          rx={rx}
          ry={rx}
          width={w}
          height={barHeight}
        />
      ))}
    </ContentLoader>
  );
};

export default TextSkeleton;
